import React from 'react'
import { Image, StyleSheet } from 'react-native'

import { B4, Icon, Pressable, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { useUnsafeVariable } from 'nativewind'

interface Props {
  seeMore: boolean
  count?: number
  onPress: () => void
  isBMSFlow: boolean
}

const SeeMoreFooter = ({ seeMore, count = 0, onPress, isBMSFlow }: Props) => {
  const [colorPrimary100] = useUnsafeVariable('--color-primary-100')

  return (
    <Pressable
      onPress={onPress}
      className="mb-3 mt-4 flex-row justify-center align-middle"
    >
      {isBMSFlow ? (
        <XStack className="absolute items-center">
          <B4 className="text-primary-100">
            {i18n.t(seeMore ? 'brandCard.seeMoreBMS' : 'brandCard.seeLessBMS')}
          </B4>
          <Icon
            type={seeMore ? 'ArrowDown' : 'ArrowTop'}
            size={20}
            color={colorPrimary100}
          />
        </XStack>
      ) : (
        <B4 className="absolute">
          {i18n.t(seeMore ? 'brandCard.seeMore' : 'brandCard.seeLess', {
            count,
          })}
        </B4>
      )}
      <Stack className="h-6 w-[100%]">
        {isBMSFlow ? (
          <Image
            style={styles.image}
            resizeMode="contain"
            source={require('../../assets/images/seeMoreBottomLineBMS.png')}
          />
        ) : (
          <Image
            style={styles.image}
            resizeMode="contain"
            source={require('../../assets/images/seeMoreBottomLine.png')}
          />
        )}
      </Stack>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  image: {
    // position: 'absolute',
    height: 20,
    width: '100%',
    alignSelf: 'stretch',
    marginTop: 7,
  },
})

export default SeeMoreFooter
